import $ from 'jquery'
import BaseRouter from 'scoreboard/components/base-router'
import appDisplay from 'scoreboard/components/app-display'
import Briefing from 'scoreboard/briefings/briefing'
import BriefingsEdit from 'scoreboard/briefings/briefings-edit'
import BriefingsNav from './briefings-nav'
import BriefingsFolderOverview from 'scoreboard/briefings/briefings-folder-overview'
import FolderForm from 'scoreboard/components/folder-form'
import _ from 'lodash'
import tabs from 'scoreboard/components/view-edit-tabs.hbs'
import SlidesEdit from './slides-edit'
import briefer from './briefer'
import globals from 'scoreboard/components/globals'
import notFound from 'scoreboard/components/not-found.hbs'
import BriefingsOverview from './briefings-overview'
import EmptyState from 'scoreboard/components/empty-state'
import noSlides from './no-slides.hbs'
import noPermission from 'scoreboard/components/no-permission.hbs'
import spectator from 'scoreboard/components/spectator'
import conductor from 'scoreboard/components/conductor'
import constants from 'scoreboard/components/constants'
import briefingsLayoutManager from 'scoreboard/briefings/briefings-layout-manager'
import getCreateFolderFunction from 'scoreboard/components/get-create-folder-function'

var BriefingsRouter = BaseRouter.extend({

	routes: {
		'briefings(/:id)(/)': 'view',
		'briefings/:id/edit(/)': 'edit',
		'briefings/:id/new(/)': 'create',
		'briefings/:id/new-folder(/)': 'createFolder',
		'organizations/:orgId/briefings/new(/)': 'createFirst',
		'organizations/:orgId/briefings/new-folder(/)': 'createFirstFolder',
		'briefings(/:id)/slides/(:slideId)/edit(/)': 'editSlide',
		'briefings(/:id)/slides/(:slideId)(/)': 'view'
	},

	Nav: BriefingsNav,
	Model: Briefing,
	section: 'briefings',

	view: function(id, slideId) {
		// #23510 fix so we definitely display the briefings nav pane when in
		// the briefings section
		if (!briefingsLayoutManager.isPaused() && conductor.section() === 'briefings') {
			spectator.setCurrent(null)
		}
		if (id) {
			appDisplay.display(this.load(id, {subscriptions: true}), function(model) {
				return this.overviewWithModel(model, slideId)
			}.bind(this))
		}
		this.nav({ id })
	},

	overviewWithModel: function(model, slideId) {
		briefer.lastLoadedBriefing = model
		if (model.get('type') === 'folder') {
			if (!briefingsLayoutManager.isPaused()) {
				briefer.toggleBriefingLayout(false)
			}
			return new BriefingsFolderOverview({ model: model, tabs: tabs, overviewTabCode: 'common.view' })
		} else {
			if (model.slides().length == 0) {
				// must go before return statement
				briefer.show(model, slideId, constants.BRIEFING_MODE_IS_VIEWING_SLIDE)
				appDisplay.display( new EmptyState({ body: noSlides() }).render().el )
			} else {
				var slide = model.slides().get(slideId)
				// retrieve the first slide if possible when none specified
				if (_.isEmpty(slideId) && model.slides().length != 0) {
					slide = model.slides().at(0)
					slideId = slide.id
				}

				// briefer.show must go after slideId is set
				// #12682 also must be BEFORE calling the BriefingOverview so
				// the correct calendar period adjustments take place
				briefer.show(model, slideId, constants.BRIEFING_MODE_IS_VIEWING_SLIDE)
				new BriefingsOverview({ model: model, slideId: slideId }).render()
			}
			briefer.lastLoadedBriefing = model
		}
	},

	edit: function(id) {
		const modelPromise = this.load(id, {subscriptions: true, slideSubLabels: true})
		const navPromise = this.navForModel({ id, edit: true }, modelPromise)
		appDisplay.display(modelPromise, model => {
			if (!model.isEditable()) {
				navPromise.then(navView => navView.toggleEditViewState(false))
				return new EmptyState({ body: noPermission() })
			}
			if (model.get('type') === 'folder') {
				if (!briefingsLayoutManager.isPaused()) {
					briefer.toggleBriefingLayout(false)
				}
				return new FolderForm({ model: model, tabs: tabs, overviewTabCode: 'common.view' })
			} else {
				briefer.show(model, null, constants.BRIEFING_MODE_IS_EDITING_BRIEFING)
				return new BriefingsEdit({ model: model })
			}
		})
	},

	create: function(relativeId, orgId) {
		// We do this to get the orgId if it's not set
		$.when(this._resolveOrg(relativeId, orgId)).done(() => {
			const organizationId = orgId || globals.orgId
			var briefing = new Briefing({
				relativeId: relativeId,
				organizationId,
				type: 'briefing',
				icon: 'briefings'
			})
			briefer.show(briefing, null, constants.BRIEFING_MODE_IS_EDITING_BRIEFING)
			var form = new BriefingsEdit({ model: briefing })
			this.navForNewModel({
				relativeId,
				orgId: organizationId,
				form,
				model: briefing
			})
		})
	},

	createFolder: function(relativeId, orgId) {
		getCreateFolderFunction(false).call(this, relativeId, orgId)
		// #58805 don't show the briefing layout when creating a folder
		briefer?.toggleBriefingLayout(false)
	},

	createFirst: function (orgId) {
		this.create(null, orgId)
	},

	createFirstFolder: function (orgId) {
		this.createFolder(null, orgId)
	},

	editSlide: function(briefingId, slideId) {
		const modelPromise = this.load(briefingId, {slideId})
		appDisplay.display(modelPromise, briefing => {
			if (!briefing.isEditable()) {
				return new EmptyState({ body: noPermission() })
			}
			briefer.show(briefing, slideId, constants.BRIEFING_MODE_IS_EDITING_SLIDE)
			var slide = briefing.slides().get(slideId)
			if (slide) {
				return new SlidesEdit({ model: slide })
			} else {
				return notFound()
			}
		})
		this.navForModel({ id: briefingId, edit: true }, modelPromise)
	}

})

export default BriefingsRouter

BriefingsRouter.__filename__ = 'briefings/briefings-router.js'
